import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import AdminUsersPanel from '../../components/AdminUsersPanel'

const AccountAdminPage: React.FC = () => {
  const { user } = useAuth()

  if (!user) return null
  if (!user.isAdmin) return <Navigate to="/account" replace />

  return (
    <div>
      <h1 className="font-serif text-2xl text-ink mb-1">Brugerstyring</h1>
      <p className="text-sm text-ink-500 mb-6">
        Opret og administrer brugere i Xosa Origin.
      </p>
      <AdminUsersPanel embedded />
    </div>
  )
}

export default AccountAdminPage
